import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CoachSidebar from '../components/CoachSidebar';

function formatarData(valor) {
  if (!valor) return '—';

  try {
    return new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short'
    }).format(new Date(valor));
  } catch {
    return '—';
  }
}

export default function CoachParticipante() {
  const navigate = useNavigate();
  const { participantId } = useParams();

  const [participante, setParticipante] = useState(null);
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  useEffect(() => {
    let ativo = true;

    async function carregar() {
      try {
        setErro('');

        const response = await fetch(
          `/api/coach/participantes/${encodeURIComponent(participantId)}/avaliacoes`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              Accept: 'application/json'
            }
          }
        );

        const data = await response.json().catch(() => ({}));

        if (!response.ok || !data.ok) {
          throw new Error(
            data.error || 'Não foi possível carregar as avaliações.'
          );
        }

        if (ativo) {
          setParticipante(data.participante || null);
          setAvaliacoes(data.avaliacoes || []);
        }
      } catch (e) {
        if (ativo) {
          setErro(
            e.message || 'Não foi possível carregar as avaliações.'
          );
        }
      } finally {
        if (ativo) {
          setLoading(false);
        }
      }
    }

    carregar();

    return () => {
      ativo = false;
    };
  }, [participantId]);

  return (
    <>
      <CoachSidebar />
      <main
      style={{
        minHeight: '100vh',
        background: '#f4f4f4',
        padding: '2.5rem 1.5rem',
        boxSizing: 'border-box',
        marginLeft: 220
      }}
    >
      <div
        style={{
          maxWidth: 1180,
          margin: '0 auto'
        }}
      >
        <button
          type="button"
          onClick={() => navigate('/coach')}
          style={{
            background: '#fff',
            color: '#242F3C',
            border: '1px solid #D8DEE6',
            borderRadius: 8,
            padding: '10px 16px',
            fontWeight: 700,
            cursor: 'pointer',
            marginBottom: 22
          }}
        >
          Voltar
        </button>

        <div
          style={{
            marginBottom: 24
          }}
        >
          <h1
            style={{
              margin: 0,
              color: '#242F3C',
              fontSize: '2rem'
            }}
          >
            {participante?.nome || 'Participante'}
          </h1>

          <div
            style={{
              marginTop: 8,
              color: '#697382'
            }}
          >
            {participante?.email || '—'}
          </div>

          <div
            style={{
              marginTop: 4,
              color: '#697382'
            }}
          >
            {participante?.empresa || '—'}
            {participante?.cargo ? ` · ${participante.cargo}` : ''}
          </div>
        </div>

        {erro && (
          <div
            role="alert"
            style={{
              marginBottom: 20,
              padding: '12px 14px',
              borderRadius: 8,
              background: '#FFF3F2',
              color: '#B42318',
              border: '1px solid #FECDCA',
              fontWeight: 600
            }}
          >
            {erro}
          </div>
        )}

        <section
          style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 2px 10px rgba(36,47,60,0.06)',
            overflowX: 'auto'
          }}
        >
          <div
            style={{
              padding: '1.5rem',
              borderBottom: '1px solid #EEF0F2'
            }}
          >
            <h2
              style={{
                margin: 0,
                color: '#242F3C',
                fontSize: '1.25rem'
              }}
            >
              Avaliações ICV
            </h2>

            <div
              style={{
                color: '#697382',
                marginTop: 6,
                fontSize: '0.92rem'
              }}
            >
              {loading
                ? 'Carregando...'
                : `${avaliacoes.length} avaliação${avaliacoes.length === 1 ? '' : 'ões'}`}
            </div>
          </div>

          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              minWidth: 760
            }}
          >
            <thead style={{ background: '#f7f7f7' }}>
              <tr>
                <th style={th}>Data</th>
                <th style={th}>Status</th>
                <th style={th}>Resultado</th>
                <th style={th}>Ações</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      padding: '2rem',
                      textAlign: 'center',
                      color: '#697382'
                    }}
                  >
                    Carregando avaliações...
                  </td>
                </tr>
              ) : (
                avaliacoes.map(avaliacao => (
                  <tr key={avaliacao.session_id}>
                    <td style={td}>
                      {formatarData(
                        avaliacao.scored_at ||
                        avaliacao.submitted_at ||
                        avaliacao.started_at
                      )}
                    </td>

                    <td style={td}>
                      {avaliacao.status || '—'}
                    </td>

                    <td style={td}>
                      {Number(avaliacao.possui_resultado) === 1
                        ? 'Disponível'
                        : 'Não disponível'}
                    </td>

                    <td style={td}>
                      {Number(avaliacao.possui_resultado) === 1 ? (
                        <button
                          type="button"
                          onClick={() =>
                            navigate(
                              `/relatorio-icv?session=${encodeURIComponent(
                                avaliacao.session_id
                              )}&acesso=coach`
                            )
                          }
                          style={{
                            background: '#242F3C',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 8,
                            padding: '9px 14px',
                            fontWeight: 700,
                            cursor: 'pointer'
                          }}
                        >
                          Ver relatório
                        </button>
                      ) : (
                        '—'
                      )}
                    </td>
                  </tr>
                ))
              )}

              {!loading && avaliacoes.length === 0 && (
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      padding: '2.5rem',
                      textAlign: 'center',
                      color: '#697382'
                    }}
                  >
                    Este Participante ainda não possui avaliações.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </div>
    </main>
    </>
  );
}

const th = {
  padding: 14,
  borderBottom: '2px solid #e6e6e6',
  textAlign: 'left',
  color: '#242F3C',
  whiteSpace: 'nowrap'
};

const td = {
  padding: 14,
  borderBottom: '1px solid #eef0f2',
  verticalAlign: 'middle'
};




